export default {
  deviceRemoved: 'Device removed',
  deviceUpdated: 'Device updated',
  deviceAdded: 'Device added',
  devices: 'Devices',
  deviceUnassigned: 'Device unassigned',
  assignToUser: 'Assign to user',
  deviceConfigs: 'Device configs'
}
